// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"2e492ee107788ea8c805","966":"f09c078c6eb8995999eb"}[chunkId] + ".js";
};